/* Bonst buy box extras – gift lines on subscription + optional add-on.
   Works next to bonst-buy-box (assets/bonst-buy-box.js) without changing it. */
(function () {
  if (customElements.get('bonst-bb-extras')) return;

  function money(cents, format) {
    var fmt = format || '{{amount_with_comma_separator}} kr';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount_with_comma_separator';
    var th = /space/.test(key) ? ' ' : /comma/.test(key) ? '.' : /apostrophe/.test(key) ? "'" : ',';
    var dec = /comma|space/.test(key) ? ',' : '.';
    var v = (Math.round(cents) / 100).toFixed(/no_decimals/.test(key) ? 0 : 2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
    v = parts[1] ? parts[0] + dec + parts[1] : parts[0];
    return m ? fmt.replace(m[0], v) : v;
  }

  var GIFT_SVG = '<svg aria-hidden="true" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="3" y="8" width="14" height="9" rx="1"/><path d="M2.5 5.5h15V8h-15zM10 5.5V17M10 5.5C8.5 2.5 5.5 3 6 4.6c.4 1.2 4 .9 4 .9zm0 0c1.5-3 4.5-2.5 4-.9-.4 1.2-4 .9-4 .9z"/></svg>';

  var AG_CSS = ".bonst-bb__opt--sub{padding-top:0!important;overflow:hidden;border-color:#3a222d!important;border-radius:1.6rem!important}\n.bonst-bb__opt--once{border-radius:1.6rem!important}\n.bonst-bb__flag{display:flex;align-items:center;gap:.8rem;margin:0 -1.8rem 1.4rem;padding:.7rem 1.8rem;background:#3a222d;color:#f7f4e6;font-size:1.15rem;font-weight:600;letter-spacing:.12em;text-transform:uppercase}\n.bonst-bb__flag svg{width:1.2rem;height:1.2rem;color:#e19128}\n.bonst-bb__opt--sub .bonst-bb__opt-badge{display:none!important}\n.bonst-bb__save-pill{display:inline-block;margin-left:.8rem;padding:.25rem .8rem;border-radius:.6rem;background:#fbe6c8;color:#3a222d;font-size:1.15rem;font-weight:700;letter-spacing:.05em;vertical-align:middle;white-space:nowrap}\n.bonst-bb__per-day{display:block;font-size:1.2rem;opacity:.65;font-weight:400;text-align:right}\n.bonst-bb__opt--once .bonst-bb__opt-title,.bonst-bb__opt--once .bonst-bb__opt-price b{font-weight:500}\n.bonst-bb__opt--once:not(:has(:checked)){background:transparent;opacity:.85}";

  function rowEl(label, value, fmt) {
    var li = document.createElement('li');
    var name = document.createElement('span');
    name.className = 'bonst-bb__first-name';
    name.textContent = label;
    var price = document.createElement('span');
    price.className = 'bonst-bb__first-price';
    if (value > 0) {
      var s = document.createElement('s');
      s.textContent = money(value, fmt);
      price.appendChild(s);
    }
    var b = document.createElement('b');
    b.textContent = 'Gratis';
    price.appendChild(b);
    li.appendChild(name);
    li.appendChild(price);
    return li;
  }

  class BonstBbExtras extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('bonst-buy-box').then(() => setTimeout(() => this.init(), 0));
    }

    init() {
      if (this.ready) return;
      this.ready = true;
      try { this.data = JSON.parse(this.querySelector('[data-bbx-json]').textContent); } catch (e) { return; }
      this.data.swap = this.data.swap || {};
      this.box = document.querySelector('bonst-buy-box[data-section-id="' + this.dataset.sectionId + '"]');
      if (!this.box) return;
      this.props = Array.prototype.slice.call(this.querySelectorAll('[data-bbx-prop]'));
      this.card = this.querySelector('[data-bbx-addon-card]');
      if (this.card) {
        var pf = this.box.querySelector('.bonst-bb__product-form');
        this.box.insertBefore(this.card, pf);
        this.addon = this.card.querySelector('[data-bbx-addon]');
        var av = this.data.addon && String(this.data.addon.variant);
        this.addonIsGift = !!av && this.data.gifts.some((g) => String(g) === av);
      }
      var subCard = this.box.querySelector('.bonst-bb__opt--sub');
      if (subCard && this.data.giftLabel) {
        var teaser = document.createElement('span');
        teaser.className = 'bonst-bb__sub-teaser';
        teaser.innerHTML = GIFT_SVG + '<span></span>';
        teaser.querySelector('span').textContent = this.data.giftLabel;
        var head = subCard.querySelector('.bonst-bb__opt-head');
        if (head) head.insertAdjacentElement('afterend', teaser);
      }
      var body = subCard && subCard.querySelector('.bonst-bb__opt-body');
      if (body) {
        this.saveEl = document.createElement('p');
        this.saveEl.className = 'bonst-bb__sub-save';
        body.insertBefore(this.saveEl, body.firstChild);
        var rows = (this.data.rows || []).filter((r) => r && r.label);
        var hasSwap = Object.keys(this.data.swap).length > 0;
        if (rows.length || hasSwap) {
          var fmt0 = this.box.data && this.box.data.moneyFormat;
          var wrap = document.createElement('div');
          wrap.className = 'bonst-bb__first';
          var h = document.createElement('p');
          h.className = 'bonst-bb__first-head';
          h.textContent = 'Første levering inkluderer';
          var ul = document.createElement('ul');
          ul.setAttribute('role', 'list');
          rows.forEach((r) => ul.appendChild(rowEl(r.label, r.value, fmt0)));
          if (hasSwap) {
            this.swapEl = rowEl('', 0, fmt0);
            ul.appendChild(this.swapEl);
          }
          wrap.appendChild(h);
          wrap.appendChild(ul);
          var perks = body.querySelector('.bonst-bb__perks');
          if (perks) perks.insertAdjacentElement('afterend', wrap); else body.appendChild(wrap);
        }
      }
      this.agStyle();
      var later = () => setTimeout(() => this.sync(), 20);
      this.box.addEventListener('change', later);
      this.box.addEventListener('click', later);
      this.box.addEventListener('input', later);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubV = subscribe(PUB_SUB_EVENTS.variantChange, later);
        this.unsubC = subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
          if (!evt || evt.source !== 'product-form') return;
          if (this.box.findVariant && !this.box.findVariant(evt.productVariantId)) return;
          this.addExtras(evt.productVariantId);
        });
      }
      later();
    }

    disconnectedCallback() {
      if (this.unsubV) this.unsubV();
      if (this.unsubC) this.unsubC();
    }


    // AG1-style purchase options: subscription first, flagged and preselected
    agStyle() {
      if (this.agDone) return;
      this.agDone = true;
      if (!document.getElementById('bonst-bb-ag')) {
        var st = document.createElement('style');
        st.id = 'bonst-bb-ag';
        st.textContent = AG_CSS;
        document.head.appendChild(st);
      }
      var subCard = this.box.querySelector('.bonst-bb__opt--sub');
      var onceCard = this.box.querySelector('.bonst-bb__opt--once');
      if (!subCard) return;
      var flag = document.createElement('span');
      flag.className = 'bonst-bb__flag';
      flag.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4z"/></svg>Best verdi';
      var input = subCard.querySelector('.bonst-bb__opt-input');
      subCard.insertBefore(flag, input ? input.nextSibling : subCard.firstChild);
      var title = subCard.querySelector('.bonst-bb__opt-title');
      if (title) {
        var m = title.textContent.match(/(\d+[.,]?\d*)\s*%/);
        title.textContent = 'Månedlig abonnement';
        var pill = document.createElement('span');
        pill.className = 'bonst-bb__save-pill';
        pill.textContent = 'Spar ' + (m ? m[1] : '15') + ' %';
        title.appendChild(pill);
      }
      var price = subCard.querySelector('.bonst-bb__opt-price');
      if (price) {
        this.perDayEl = document.createElement('span');
        this.perDayEl.className = 'bonst-bb__per-day';
        price.appendChild(this.perDayEl);
      }
      if (onceCard) {
        var ot = onceCard.querySelector('.bonst-bb__opt-title');
        if (ot) ot.textContent = 'Kjøp én gang';
        if (subCard.parentNode === onceCard.parentNode && subCard.compareDocumentPosition(onceCard) & Node.DOCUMENT_POSITION_PRECEDING) {
          subCard.parentNode.insertBefore(subCard, onceCard);
        }
      }
      if (!this.box.querySelector('.bonst-bb__opt-input:checked') && input) input.click();
    }

    isSub() {
      var r = this.box.querySelector('.bonst-bb__opt-input:checked');
      return !!(r && r.value === 'sub');
    }

    currentSwap(variantId) {
      var id = variantId || (this.box.variant && this.box.variant.id);
      return id ? this.data.swap[String(id)] || null : null;
    }

    sync() {
      var sub = this.isSub();
      this.props.forEach((p) => { p.disabled = !sub; });
      if (this.swapEl) {
        var sw = this.currentSwap();
        this.swapEl.hidden = !sw;
        if (sw) this.swapEl.querySelector('.bonst-bb__first-name').textContent = sw.label;
      }
      if (this.saveEl && this.box.variant && this.box.total && this.box.qtyInput) {
        var q = parseInt(this.box.qtyInput.value, 10) || 1;
        var saved = this.box.variant.price * q - this.box.total(q, true);
        var f = this.box.data && this.box.data.moneyFormat;
        if (saved > 0) {
          this.saveEl.innerHTML = 'Du sparer <b></b> hver måned';
          this.saveEl.querySelector('b').textContent = money(saved, f);
          this.saveEl.hidden = false;
        } else {
          this.saveEl.hidden = true;
        }
      }
      if (this.perDayEl && this.box.variant && this.box.total && this.box.qtyInput) {
        var qd = parseInt(this.box.qtyInput.value, 10) || 1;
        var unitsEl = this.box.querySelector('[data-bb-units]');
        var days = (unitsEl ? parseInt(unitsEl.dataset.bbUnits, 10) : 30) || 30;
        var tot = this.box.total(qd, true);
        this.perDayEl.textContent = tot ? 'ca. ' + money(tot / days, this.box.data && this.box.data.moneyFormat) + ' per dag' : '';
      }
      if (!this.card) return;
      // the bottle is already a free gift on subscription – don't sell it as an add-on then
      var hideAddon = sub && this.addonIsGift;
      this.card.hidden = hideAddon;
      if (hideAddon) this.addon.checked = false;
      this.card.classList.toggle('is-selected', !!this.addon.checked);
      var bp = this.box.querySelector('[data-bb-btn-price]');
      if (!bp || !bp.textContent.trim() || !this.box.total || !this.box.qtyInput) return;
      var qty = parseInt(this.box.qtyInput.value, 10) || 1;
      var base = this.box.total(qty, sub);
      var fmt = this.box.data && this.box.data.moneyFormat;
      bp.textContent = money(base + (this.addon.checked ? this.data.addon.price : 0), fmt);
    }

    addExtras(variantId) {
      var sub = this.isSub();
      var d = this.data;
      var sw = sub ? this.currentSwap(variantId) : null;
      var wantAddon = this.addon && this.addon.checked && d.addon && !(sub && this.addonIsGift);
      if (!(sub && (d.gifts.length || sw)) && !wantAddon) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((cart) => {
          var has = (id) => cart.items.some((i) => String(i.variant_id) === String(id));
          var items = [];
          if (sub) {
            d.gifts.forEach((id) => {
              if (has(id)) return;
              var props = d.ref
                ? { '_appstle-bb-id': d.ref, '__appstle-bb-name': d.name || '', '_appstle_bundles_type': 'BUY_X_GET_Y' }
                : { '_bonst_gave': 'Første levering' };
              items.push({ id: id, quantity: 1, properties: props });
            });
            if (sw && !has(sw.id)) items.push({ id: sw.id, quantity: 1, properties: { '_bonst_gave': 'Første levering' } });
          }
          if (wantAddon && !has(d.addon.variant)) items.push({ id: d.addon.variant, quantity: 1 });
          if (!items.length) return null;
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(() => fetch(window.location.pathname + '?sections=cart-icon-bubble'))
            .then((r) => r.json())
            .then((s) => {
              var t = document.getElementById('cart-icon-bubble');
              var html = s && s['cart-icon-bubble'];
              if (!t || !html) return;
              var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
              if (src) t.innerHTML = src.innerHTML;
            });
        })
        .catch(() => {});
    }
  }

  customElements.define('bonst-bb-extras', BonstBbExtras);
})();
